import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicYoutubeCarousel {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        perPage: 3,
        type: 'slide',
        autoplay: false,
        arrows: false,
        pagination: false,
        gap: '16px',
        padding: '16px',
        breakpoints: {
          [unitlessBreakpoints.sm]: {
            perPage: 1,
          },
        },
      },
      true,
    );
  }
}
